import Header from "@/components/landing/Header";
import Hero from "@/components/landing/Hero";
import TransitionSection from "@/components/landing/TransitionSection";
import SocialProof from "@/components/landing/SocialProof";
import Benefits from "@/components/landing/Benefits";
import CTASection from "@/components/landing/CTASection";
import FAQ from "@/components/landing/FAQ";
import Footer from "@/components/landing/Footer";
import FloatingWhatsApp from "@/components/landing/FloatingWhatsApp";

export default function Landing() {
  return (
    <main
      data-testid="landing-root"
      className="min-h-screen bg-[var(--buzas-bg)] text-[var(--buzas-text)]"
    >
      <Header />
      <Hero />
      <TransitionSection />
      <SocialProof />
      <Benefits />
      <CTASection />
      <FAQ />
      <Footer />
      <FloatingWhatsApp />
    </main>
  );
}
